var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPerson(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M13.25 2.459c0-.797.422-1.5 1.125-1.922.656-.422 1.547-.422 2.25 0C17.28.96 17.75 1.662 17.75 2.46c0 .844-.469 1.547-1.125 1.969-.703.422-1.594.422-2.25 0-.703-.422-1.125-1.125-1.125-1.969zm1.5 6.047v5.953h1.5V8.506c-.047 0-.094-.047-.14-.047h-1.266c-.047 0-.094 0-.094.047zm0 8.203v6.375a1.11 1.11 0 01-1.125 1.125c-.656 0-1.125-.469-1.125-1.125V10.709l-2.063 3.563c-.28.562-.984.75-1.5.421a1.052 1.052 0 01-.422-1.5l2.72-4.875c.75-1.265 2.109-2.109 3.609-2.109h1.265c1.5 0 2.86.844 3.61 2.11l2.718 4.874c.328.516.141 1.22-.422 1.5a1.052 1.052 0 01-1.5-.421L18.5 10.708v12.375a1.11 1.11 0 01-1.125 1.125c-.656 0-1.125-.469-1.125-1.125v-6.375h-1.5z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPerson);
export default ForwardRef;
